type Pension = {
  income: number
  isTemporary: boolean
  type: string
}

type Result = {
  index: number
  pension: Pension
  income: number
}

export function getHighestRetirementPension(pensions: Pension[]): Result {
  const retirementTypes = ['PENSION', 'RETIREMENT_PENSION']

  const filtered = pensions
    .map((pension, index) => ({ pension, index }))
    .filter((item) => retirementTypes.includes(item.pension.type))

  if (filtered.length === 0)
    return {
      index: 0,
      pension: { income: 0, isTemporary: false, type: '' },
      income: 0
    }

  const highest = filtered.reduce((max, curr) =>
    curr.pension.income > max.pension.income ? curr : max
  )

  return {
    index: highest.index,
    pension: highest.pension,
    income: highest.pension.income
  }
}
